<template>
  <v-dialog
    v-model="dialog"
    persistent
    content-class="confirmation-dialog__content"
    @keydown.enter="onClick(0)"
    @keydown.esc="disableEsc ? null : onClick(1)"
  >
    <v-card>
      <v-card-title class="text-h6 text-sm-h5">
        {{ title }}
      </v-card-title>

      <v-card-text>
        <template v-if="message">
          <div
            v-for="(text, index) in message.split('\n')"
            :key="index"
          >
            {{ text }}
          </div>
        </template>
        <slot />
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          :color="confirmColor"
          @click="onClick(0)"
        >
          {{ confirmTitle || $t('button.yes') }}
        </v-btn>

        <v-btn
          v-if="!hideCancel"
          color="error"
          text
          @click="onClick(1)"
        >
          {{ cancelTitle || $t('button.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import DialogClosable from '@/mixins/dialog-closable';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'ConfirmationDialog',
  mixins: [DialogClosable],
  props: {
    title: { type: String as PropType<string>, required: true },
    message: { type: String as PropType<string>, required: false, default: undefined },
    confirmTitle: { type: String as PropType<string>, required: true },
    confirmColor: { type: String as PropType<string>, required: false, default: 'success' },
    cancelTitle: { type: String as PropType<string>, required: true },
    hideCancel: { type: Boolean, required: false, default: false },
    disableEsc: { type: Boolean, required: false, default: false },
  },
  data: () => ({ }),
  methods: {
    onClick(ret: number) {
      switch (ret) {
        case 0:
          this.$emit('confirm');
          break;
        case 1:
          this.$emit('cancel');
          break;
        default:
          break;
      }
      this.$emit('close', true);
    },
  },
});

export interface ConfirmationDialogData {
  // visible: boolean,
  title: string,
  message: string,
  confirmTitle: string,
  cancelTitle: string,
  confirm: () => void,
  // cancel: () => void,
  // close: () => void,
}

</script>

<style lang="scss">
.confirmation-dialog__content {
  display: inline-block;
  width: auto;
  min-width: 450px;
  max-width: 650px;
}
</style>
